export default __webpack_public_path__ + "static/media/home-banner-1.b4607ba8.png";